import React, { useEffect } from "react";

const Toc: React.FC<{
  tableOfContents: string;
}> = ({ tableOfContents }) => {
  useEffect(() => {
    document.querySelectorAll('.toc-list a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelector(decodeURIComponent(this.getAttribute("href")))
          .scrollIntoView({
            behavior: "smooth",
          });
      });
    });
  }, []);
  return (
    <div className="sticky top-10 translate-y-28">
      <div
        className="toc-list absolute w-52 right-0 -translate-x-1/3 overflow-hidden 2xl:-translate-x-full"
        dangerouslySetInnerHTML={{ __html: tableOfContents }}
      />
    </div>
  );
};

export default Toc;
